import { TrackedChangeType, TrackedChange } from 'prose-core'
import { Transaction } from 'prosemirror-state'
import { Node } from 'prosemirror-model'
import dayjs from 'dayjs'
import { omit, isEqual } from 'lodash'
import { ourUuid } from 'utils'
import { isInsertion } from './utils'
import { Context } from './Types'

const IGNORED_ATTRS = ['trackedChanges', 'blockId']

export function addWrappingMarks(
  tr: Transaction,
  pos: number,
  oldNode: Node,
  newNode: Node,
  userId: number,
  context?: Context,
) {
  /**
   * If the node is already an insertion, skip
   */
  if (isInsertion(newNode)) {
    return
  }

  let trackedChanges = oldNode.attrs.trackedChanges || []
  let nodeTypeTrackedChange = trackedChanges.find(
    ({ type }: TrackedChange) => type === TrackedChangeType.NodeTypeChange,
  )
  const createdAt = nodeTypeTrackedChange ? nodeTypeTrackedChange.createdAt : dayjs().toISOString()
  const uuid = context?.uuid || nodeTypeTrackedChange?.uuid || ourUuid()

  // The node was already tracked with a wrapping change
  if (nodeTypeTrackedChange) {
    trackedChanges = trackedChanges.filter(({ type }: TrackedChange) => type !== TrackedChangeType.NodeTypeChange)
    // We are not reverting the node type back to what it was originally, or
    // the same heading level, so we push a new tracked change
    if (
      nodeTypeTrackedChange.before.type !== newNode.type.name ||
      !sameAttrs(nodeTypeTrackedChange.before.attrs, newNode.attrs)
    ) {
      trackedChanges.push({
        type: TrackedChangeType.NodeTypeChange,
        userId,
        createdAt,
        uuid,
        before: nodeTypeTrackedChange.before,
      })
    }
  } else {
    trackedChanges.push({
      type: TrackedChangeType.NodeTypeChange,
      createdAt,
      userId,
      uuid,
      before: {
        type: oldNode.type.name,
        attrs: omit(oldNode.attrs, IGNORED_ATTRS),
      },
    })
  }

  if (tr.doc.nodeAt(pos)) {
    // @ts-ignore
    tr.setNodeMarkup(pos, null, Object.assign({}, newNode.attrs, { trackedChanges }))
  }
}

function sameAttrs(oldAttrs: object, newAttrs: object) {
  return isEqual(omit(oldAttrs, IGNORED_ATTRS), omit(newAttrs, IGNORED_ATTRS))
}
